export default __webpack_public_path__ + "static/media/INTROBOLD.bbda238d.OTF";